import UserInfoSmall from './UserInfoSmall';

export default UserInfoSmall;
